// Shared source-of-truth for the terum-capture (Claude Code) install commands.
//
// The OS→command mapping must never drift between the Sources "Connect Claude Code"
// modal (components/shared/ClaudeCodeInstall) and the onboarding wizard
// (components/onboarding/ClaudeCodeStep). macOS/Linux use terum-capture's install.sh
// one-liner — it finds a Python, installs pipx if missing, and falls back to uv with
// a self-contained Python when pipx can't work (bare `pipx install` fails outright on
// macOS 26.1/26.2, where every Homebrew Python returns an empty platform.mac_ver()
// and pipx ≥1.16's uv backend refuses it). Windows routes through
// `py -m pip install --user …` + `py -m terum_capture setup` so every step runs via
// the code-signed Python interpreter that Windows Smart App Control trusts — the
// unsigned pipx / console-script `.exe` shim is blocked on SAC-enforcing machines,
// which otherwise silently kills capture (install.sh is bash-only, so Windows cannot
// use the one-liner).
//
// Install is from git main, so the `py -m terum_capture` entry requires
// terum-capture's `__main__.py` to be on main — ship UI using these only after that.

export type OS = 'unix' | 'windows';

export const OS_TABS: { key: OS; label: string }[] = [
  { key: 'unix', label: 'macOS / Linux' },
  { key: 'windows', label: 'Windows' },
];

export const CLAUDE_CODE_COMMANDS: Record<OS, { install: string; auth: string }> = {
  unix: {
    install:
      'curl -fsSL https://raw.githubusercontent.com/ryanliu-terum/terum-capture/main/install.sh | bash',
    auth: 'terum-capture setup',
  },
  windows: {
    install: 'py -m pip install --user git+https://github.com/ryanliu-terum/terum-capture',
    auth: 'py -m terum_capture setup',
  },
};

/** Best-effort OS for the default tab; the user can switch. `hint` is overridable for tests. */
export function detectOS(hint?: string): OS {
  const probe = (
    hint ?? (typeof navigator !== 'undefined' ? `${navigator.userAgent} ${navigator.platform}` : '')
  ).toLowerCase();
  return probe.includes('win') ? 'windows' : 'unix';
}
